/**
 * SEO Utility Functions
 * UTF-8 safe string operations for Turkish characters
 */

const BASE_URL = 'https://studioasimmete.com';

/**
 * Creates a URL-friendly slug from Turkish text
 * Handles Turkish characters (ç, ğ, ı, ö, ş, ü) correctly
 */
export function createSlug(text: string): string {
  return text
    .toLowerCase()
    .trim()
    .replace(/ç/g, 'c')
    .replace(/ğ/g, 'g')
    .replace(/ı/g, 'i')
    .replace(/ö/g, 'o')
    .replace(/ş/g, 's')
    .replace(/ü/g, 'u')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/**
 * Path'i boşluk ve özel karakterler için URL-encode eder (canlı ortamda görsellerin yüklenmesi için)
 */
function encodePath(path: string): string {
  const normalized = path.startsWith('/') ? path.slice(1) : path;
  return normalized
    .split('/')
    .map((segment) => encodeURIComponent(segment))
    .join('/');
}

/**
 * Görsel URL'i döndürür: base path + encode edilmiş path. Canlıda ve local'de görsellerin doğru yüklenmesi için kullanın.
 */
export function getImageUrl(path: string): string {
  if (path.startsWith('http')) return path;
  const base = (typeof import.meta !== 'undefined' && import.meta.env?.BASE_URL) || '/';
  const encoded = encodePath(path);
  return base.endsWith('/') ? `${base}${encoded}` : `${base}/${encoded}`;
}

/**
 * Gets full URL for a path (absolute URL for SEO, og:image vb.)
 */
export function getFullUrl(path: string): string {
  if (path.startsWith('http')) return path;
  const p = path.startsWith('/') ? path.slice(1) : path;
  return `${BASE_URL}/${encodePath(p)}`;
}

/**
 * Gets category name in Turkish
 */
export function getCategoryName(category: string): string {
  const categoryMap: Record<string, string> = {
    'konut': 'Konut',
    'ofis': 'Ofis',
    'ticari': 'Ticari',
    'tümü': 'Tümü'
  };
  return categoryMap[category] || category;
}
